var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"Loader"},[_c('img',{attrs:{"src":"/img/loader.svg","alt":"loading"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }